import { render, staticRenderFns } from "./checkboxCollapse.vue?vue&type=template&id=76d3cbb8&scoped=true"
import script from "./checkboxCollapse.vue?vue&type=script&lang=js"
export * from "./checkboxCollapse.vue?vue&type=script&lang=js"
import style0 from "./checkboxCollapse.vue?vue&type=style&index=0&id=76d3cbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d3cbb8",
  null
  
)

export default component.exports